import React, { useEffect } from "react";
import Navbar from "./components/navbar/Navbar";
import Banner from "./components/banner/Banner";
import Features from "./components/features/Features";
import Projects from "./components/projects/Projects";
import Resume from "./components/resume/Resume";
import Footer from "./components/footer/Footer";
import ReactGA from 'react-ga';
ReactGA.initialize('G-QXTE6NKDVD');
function App() {
  useEffect(()=>{
    ReactGA.pageview(window.location.pathname);
  }, [])
  return (
    <>
      <div className="w-full h-auto bg-bodyColor text-lightText px-4">
        <Navbar />
        <div className=" max-w-screen-xl mx-auto">
          <Banner />
          <Features />
          <Projects />
          <Resume />
          <Footer />
        </div>
      </div>
    </>
  );
}

export default App;
